import { useCallback, useEffect, useMemo } from "react";
import { useTrendingNichesStore } from "../store/trendingNichesStore";
import { apiNiches } from "../services";
import { INiche } from "../services/types";
import { useFetch } from "./useFetch";

export const useTrendingNiches = () => {
  const setTrendingNiches = useTrendingNichesStore((state) => state.setTrendingNiches);
  const trendingNiches = useTrendingNichesStore((state) => state.trendingNiches);

  const fetchTrendingNiches = useCallback(() => apiNiches.getTrendingNiches(), []);
  const { isLoading, error, data } = useFetch(fetchTrendingNiches, !trendingNiches.length);

  useEffect(() => {
    if (!error && data && data.niches) {
      setTrendingNiches(data.niches);
    }
  }, [error, data, setTrendingNiches]);

  const niches = useMemo(() =>
    trendingNiches.map((el: INiche) => ({
      id: el.id,
      name: el.name,
      image: el.thumbnail,
      subscribers: el.subscribers,
    })), [trendingNiches]);

  return {
    trendingNiches: niches,
    error,
    isLoading
  };
};

